import { Routes_Interface } from "./routesInterface";

export const assetRoutes: Array<Routes_Interface> = [

]